<!--
    Cette partie ne concerne que le selecteur ici (juridicion et numéro de compostage) pour identifier un questionnaire.
    Avant d’afficher le questionnaire, on permet au gestionnaire de rentrer une juridiction et un numéro de compostage.
    Ce choix permet de ramener le bon questionnaire. Un bouton pour faire un autre choix est également disponible.
    Ne garder que ce qui est essentiel à l'enquete... A adapter suivant les variables mises dans la variable identifiante
    ex ici : avec ielst + noCmpst mais possibilité que de l'un ou l'autre voire d'autres variables identifiantes...
-->
<div class="pb-2">
  <div class="form-row">
    <form class="form primary col" [formGroup]="formulaireSelecteur">
      <div class="form-row">
        <div class="ml-xl-auto"></div>
        <div class="col-xl-8" *ngFor="let variable of variableIdentifiante">
          <ng-container
            *ngIf="utiliserFilteredSelect(variable); else elseTemplate"
          >
            <!-- juridiction -->
            <bis-filtered-select-sans-consultation-input-keypad
              [enLectureSeule]="noCmpstAffiche"
              [rootForm]="formulaireSelecteur"
              placeholder="Ti"
              [label]="variable"
              id="recupererSaisie"
              nbChoixVisiblePossible=10
              autofocus
            >
            </bis-filtered-select-sans-consultation-input-keypad>
          </ng-container>
          <ng-template #elseTemplate>
            <!-- Numero compostage si existe -->
            <bis-integer-sans-consultation-input-keypad
              [rootForm]="formulaireSelecteur"
              [enLectureSeule]="noCmpstAffiche"
              [label]="variable"
              [max]="999999"
            ></bis-integer-sans-consultation-input-keypad>
          </ng-template>
        </div>

        <span class="col-xl-2 my-sm-1 my-xl-0" *ngIf="! (modeRendu.enModeImpression$ | async)">
          <p
            style="margin-bottom: 0.5rem; display: inline-block;"
            class="d-sm-none d-xl-block"
          >&nbsp;</p>
          <button
            [disabled]="formulaireSelecteur.invalid || noCmpstAffiche"
            (click)="charger.emit()"
            class="btn btn-style btn-primary"
            title="Afficher le questionnaire"
            id="buttonAfficher"
          >
            <i class="material-icons md-18 mr-1" aria-hidden="true"
              >cloud_download</i
            >
            Afficher
          </button>
        </span>

        <span class="col-xl-2 mr-auto my-sm-1 my-xl-0 pr-2" *ngIf="! (modeRendu.enModeImpression$ | async)">
          <p
            style="margin-bottom: 0.5rem; display: inline-block;"
            class="d-sm-none d-xl-block"
          >&nbsp;</p>
          <button
            [disabled]="!noCmpstAffiche"
            class="btn btn-style btn-info"
            title="Quitter le questionnaire en cours..."
            (click)="reinitialiser.emit()"
          >
            <i class="material-icons md-18 mr-1" aria-hidden="true"
              >exit_to_app</i
            >
            Quitter
          </button>
        </span>
      </div>

    </form>
  </div>
</div>
